module.exports = __webpack_public_path__ + "static/media/icon-creme.c82c9daf.svg";